// tslint:disable

import * as Cookie from 'js-cookie';
import { get } from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
//import { Notification } from '../../index';
import { ListResourceLoader } from '../libs/list-resource-loader';
import { ListLib } from '../libs/list.lib';
import { LoaderComponent } from './loader.component';
import { IriPresenter } from './presenters/iri-presenter';
import { ListActions, ListResponsePresenterTable } from './presenters/list-response-presenter-table';
import { ToggleBoxComponent } from './toggle-box.component';
import './welcome.scss';


export class WelcomeComponent extends React.Component<any, any> {
    public state: any = {
        user: {},
        site: {},
    };

    async componentDidMount() {
        this.setState({
            user: JSON.parse(Cookie.get('user') as string),
            site: JSON.parse(Cookie.get('site') as string),
        });

        // Notification.notify({title: 'Hello'})
        // const v = await Notification.prompt('Kecske', 'Lepedék', 'warning');
        // console.log(v);
    }

    render() {
        return (
            <ListResourceLoader forceQuery={{'processed': false, 'order[processed]': 'DESC', 'order[createAt]': 'DESC', pagination: false}} entity="enquiry" render={(list: ListLib) => <div className="welcomeComponent">
                <div id="page-title">
                    <h1>Hi, {get(this.state.user, 'firstName')}!</h1>
                    <h2>Welcome on the admin dashboard of the <b>{get(this.state.site, 'name')}</b> site</h2>
                </div>
                <div className="divider"></div>
                <div className="card-columns">
                    <div className="card">
                        <ToggleBoxComponent title="Incoming enquiries" color="green" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <LoaderComponent isLoading$={list.isLoading$}/>
                                    <ListResponsePresenterTable
                                        items={list.member}
                                        head={() => {
                                            return (
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Company</th>
                                                    <th>E-mail</th>
                                                    <th>Processed</th>
                                                    <th>Created At</th>
                                                    <th></th>
                                                </tr>
                                            );
                                        }}
                                        row={(item: any, index: number, actions: ListActions) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{get(item, 'id', '-')}</td>
                                                    <td>
                                                        <IriPresenter iri={get(item, 'title[@id]', '-')} render={(title: any) => get(title, 'name')}/> {get(item, 'name', '-')}
                                                    </td>
                                                    <td>{get(item, 'company', '-')}</td>
                                                    <td>{get(item, 'email', '-')}</td>
                                                    <td>
                                                        {get(item, 'processed') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                                    </td>
                                                    <td>
                                                        {moment(get(item, 'createdAt')).format('DD/MM/Y H:mm')}
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>View enquiry</button>
                                                    </td>
                                                </tr>
                                            );
                                        }}/>
                                </div>
                            </div>
                        </ToggleBoxComponent>
                    </div>
                    <div className="card">
                        <ToggleBoxComponent title="Incoming contacts" color="green" alwaysOpen={true}>
                            <ListResourceLoader forceQuery={{'processed': false, 'order[processed]': 'DESC', 'order[createAt]': 'DESC'}} entity="contact" render={(list: ListLib) => <div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <LoaderComponent isLoading$={list.isLoading$}/>

                                        <ListResponsePresenterTable
                                            items={list.member}
                                            head={() => {
                                                return (
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Name</th>
                                                        <th>E-mail</th>
                                                        <th>Processed</th>
                                                        <th></th>
                                                    </tr>
                                                );
                                            }}
                                            row={(item: any, index: number, actions: ListActions) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{get(item, 'id', '-')}</td>
                                                        <td>
                                                            {get(item, 'firstName', '-')} {get(item, 'surName', '-')}
                                                        </td>
                                                        <td>{get(item, 'email', '-')}</td>
                                                        <td>
                                                            {get(item, 'processed') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                                        </td>
                                                        <td>
                                                            <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>View details</button>
                                                        </td>
                                                    </tr>
                                                );
                                            }}/>
                                    </div>
                                </div>
                            </div>}
                            />
                        </ToggleBoxComponent>
                    </div>
                    <div className="card">
                        <ToggleBoxComponent title="Last uploaded training" color="blue" alwaysOpen={true}>
                            <ListResourceLoader forceQuery={{'order[createdAt]': 'DESC', 'limit': 10}} entity="company-article" render={(list: ListLib) => <div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <LoaderComponent isLoading$={list.isLoading$}/>
                                        <ListResponsePresenterTable
                                            items={list.member}
                                            head={() => {
                                                return (
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Title</th>
                                                        <th>Company</th>
                                                        <th>Action</th>
                                                    </tr>
                                                )
                                            }}
                                            row={(item: any, index: number, actions: ListActions) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{get(item, 'id', '-')}</td>
                                                        <td>{get(item, 'title', 'N/A')}</td>
                                                        <td>
                                                            <IriPresenter iri={get(item, 'company.@id')} path='name'/>
                                                        </td>
                                                        <td>
                                                            <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>Edit content</button>
                                                        </td>
                                                    </tr>
                                                )
                                            }}/>
                                    </div>
                                </div>
                            </div>}
                            />
                        </ToggleBoxComponent>
                    </div>
                </div>


            </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/welcome.component.tsx